(function () {

  var _controller = null;

  function init() {

    if (_controller) _controller.abort();
    _controller = new AbortController();
    var sig = { signal: _controller.signal };

    var filterBtns   = document.querySelectorAll('.filter-btn');
    var cards        = document.querySelectorAll('.catalogue__grid .product-card');
    var emptyState   = document.getElementById('catalogue-empty');
    var view         = document.getElementById('catalogue-view');
    var panel        = document.getElementById('catalogue-panel');
    var panelContent = document.getElementById('panel-content');
    var panelClose   = document.getElementById('panel-close');
    var modal        = document.getElementById('catalogue-modal');
    var modalContent = document.getElementById('modal-content');
    var modalClose   = document.getElementById('modal-close');

    if (!filterBtns.length || !cards.length) return;

    var activeCard = null;
    var panelOpen  = false;

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

        /* Helpers */
    function getImages(card) {
      try {
        var raw = card.dataset.images;
        var urls = raw ? JSON.parse(raw) : [];
        return urls.filter(function (u) {
          return typeof u === 'string' && (u.indexOf('https://') === 0 || u.indexOf('//') === 0);
        });
      } catch (e) {
        return [];
      }
    }

        /* Formatting */
    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var fmt = window.NomNom && window.NomNom.moneyFormat ? window.NomNom.moneyFormat : '${{amount}}';
      var code = window.NomNom && window.NomNom.currencyCode ? ' ' + window.NomNom.currencyCode : '';
      return fmt.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', Math.round(cents / 100)) + code;
    }

    /* Escaping */
    function _esc(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;');
    }

    var prevArrow = [
      '<svg width="8" height="10" viewBox="0 0 8 10" xmlns="http://www.w3.org/2000/svg"',
      ' shape-rendering="crispEdges" aria-hidden="true" focusable="false">',
      '<rect x="6" y="0" width="2" height="10" fill="currentColor"/>',
      '<rect x="4" y="2" width="2" height="6" fill="currentColor"/>',
      '<rect x="2" y="4" width="2" height="2" fill="currentColor"/>',
      '</svg>'
    ].join('');

    var nextArrow = [
      '<svg width="8" height="10" viewBox="0 0 8 10" xmlns="http://www.w3.org/2000/svg"',
      ' shape-rendering="crispEdges" aria-hidden="true" focusable="false">',
      '<rect x="0" y="0" width="2" height="10" fill="currentColor"/>',
      '<rect x="2" y="2" width="2" height="6" fill="currentColor"/>',
      '<rect x="4" y="4" width="2" height="2" fill="currentColor"/>',
      '</svg>'
    ].join('');

    /* Panel HTML */
    function buildHTML(card) {
      var name      = (card.querySelector('.product-card__name') || {}).textContent || '';
      var desc      = card.dataset.desc || '';
      var variantId = card.dataset.variant || '';
      var handle    = card.dataset.handle || '';
      var url       = card.dataset.url || ('/products/' + handle);
      var tags      = (card.dataset.tags || '').split(',');
      var images    = getImages(card);
      var full      = card.querySelectorAll('.hp-bar__seg--full').length;
      var total     = card.querySelectorAll('.hp-bar__seg').length || 5;

      /* Parse Shopify variant + option data */
      var variants = [];
      var options  = [];
      try { variants = JSON.parse(card.dataset.variants || '[]'); } catch (e) {}
      try { options  = JSON.parse(card.dataset.options  || '[]'); } catch (e) {}var currentVariant = variants.filter(function (v) {
        return String(v.id) === String(variantId);
      })[0] || variants[0];

      var currentPrice = currentVariant
        ? formatMoney(currentVariant.price)
        : ((card.querySelector('.coin-price__amount') || {}).textContent || '');
      var comparePrice = (currentVariant && currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price)
        ? formatMoney(currentVariant.compare_at_price)
        : '';
      var currentAvail = currentVariant ? currentVariant.available : true;var mainImgHTML = images.length
        ? '<img src="' + images[0] + '" alt="' + _esc(name) + '" loading="eager">'
        : '<div class="panel__swatch-fill" style="background:var(--color-blush-pink)"></div>';

      var thumbsHTML = images.map(function (src, i) {
        return (
          '<button class="panel__thumb' + (i === 0 ? ' is-active' : '') + '"' +
          ' type="button" aria-label="Image ' + (i + 1) + '" data-thumb="' + i + '">' +
          '<img src="' + src + '" alt="" loading="lazy"></button>'
        );
      }).join('');

      if (!thumbsHTML) {
        thumbsHTML = '<button class="panel__thumb is-active" type="button" aria-label="Product image">' +
          '<div class="panel__swatch-fill" style="background:var(--color-blush-pink)"></div></button>';
      }

      var imagesJson   = _esc(JSON.stringify(images));
      var variantsJson = _esc(JSON.stringify(variants));

      /* Variant option selects — skip if product has only the default "Title" option */
      var hasOptions = options.length > 0 &&
        !(options.length === 1 && options[0].name === 'Title');

      var optionsHTML = '';
      if (hasOptions) {
        optionsHTML = '<div class="panel__options">' +
          options.map(function (opt, idx) {
            var selectedVal = currentVariant
              ? currentVariant['option' + (idx + 1)]
              : (opt.values[0] || '');
            var optsHTML = opt.values.map(function (val) {
              return '<option value="' + _esc(val) + '"' +
                (val === selectedVal ? ' selected' : '') + '>' + _esc(val) + '</option>';
            }).join('');
            return (
              '<div class="panel__option">' +
              '<label class="panel__option-label">' + _esc(opt.name.toUpperCase()) + '</label>' +
              '<select class="panel__option-select" data-option-index="' + idx + '">' +
              optsHTML + '</select></div>'
            );
          }).join('') +
        '</div>';
      }

      var badgeHTML = '';
      if (tags.indexOf('PreOrder') >= 0) badgeHTML += '<span class="product-card__badge-tag">PRE ORDER</span>';
      var isOnSale = card.dataset.onSale === 'true';
      if (isOnSale) badgeHTML += '<span class="product-card__badge-tag product-card__badge-tag--sale">SALE</span>';
      if (tags.indexOf('NewArrivals') >= 0) badgeHTML += '<span class="product-card__badge-tag product-card__badge-tag--new">NEW</span>';
      if (!currentAvail) badgeHTML += '<span class="product-card__badge-tag product-card__badge-tag--oos">OUT OF STOCK</span>';

      var isPreOrder = tags.indexOf('PreOrder') >= 0;
      var stockIcon;
      if (isPreOrder) {
        stockIcon = '<svg class="stock-icon stock-icon--preorder" width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="8" cy="8" r="6.5"/><path d="M8 4.5V8l2.5 1.5"/></svg>';
      } else if (currentAvail) {
        stockIcon = '<svg class="stock-icon stock-icon--instock" width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="12" height="12" rx="2"/><path d="M5 8l2 2 4-4"/></svg>';
      } else {
        stockIcon = '<svg class="stock-icon stock-icon--oos" width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="12" height="12" rx="2"/><path d="M5.5 5.5l5 5M10.5 5.5l-5 5"/></svg>';
      }

      var isPreOrder = tags.indexOf('PreOrder') >= 0;
      var isBackerKit = tags.indexOf('BackerKit') >= 0;
      var btnText = isPreOrder ? 'PRE-ORDER NOW' : (currentAvail ? 'ADD TO CART' : 'SOLD OUT');
      var btnClass = isPreOrder ? 'arcade-btn--preorder' : 'arcade-btn--primary';

      var atcHTML;
      if (isBackerKit && isPreOrder) {
        atcHTML = '<a class="arcade-btn arcade-btn--preorder panel__atc-btn" href="https://www.backerkit.com/call_to_action/7bb28eb4-2f00-4627-bbee-576862a429d8/landing" target="_blank" rel="noopener">PRE-ORDER NOW</a>';
      } else {
        atcHTML = '<button class="arcade-btn ' + btnClass + ' panel__atc-btn" type="button"' +
            ' data-variant="' + variantId + '"' +
            ' data-variants="' + variantsJson + '"' +
            ' data-preorder="' + (isPreOrder ? 'true' : 'false') + '"' +
            (!currentAvail && !isPreOrder ? ' disabled aria-disabled="true"' : '') + '>' +
            btnText +
          '</button>';
      }

      var comparePriceHTML = comparePrice
        ? ' <span class="panel__compare-price">' + _esc(comparePrice) + '</span>'
        : '';

      var disclaimerHTML = (isBackerKit && isPreOrder)
        ? '<p class="panel__disclaimer">This will open BackerKit in a new tab to complete your pre-order.</p>'
        : '';

      return (
        '<h2 class="panel__title">' + _esc(name) + '</h2>' +

        '<div class="panel__gallery">' +
          '<div class="panel__gallery-main" data-gallery-images="' + imagesJson + '">' +
            badgeHTML +
            '<div class="panel__gallery-img">' + mainImgHTML + '</div>' +
            '<button class="panel__gallery-prev" type="button" aria-label="Previous image">' + prevArrow + '</button>' +
            '<button class="panel__gallery-next" type="button" aria-label="Next image">' + nextArrow + '</button>' +
          '</div>' +
          '<div class="panel__thumbs">' + thumbsHTML + '</div>' +
        '</div>' +

        '<div class="panel__meta">' +
          '<p class="panel__price">' +
            '<span class="coin-price__amount panel__current-price">' + _esc(currentPrice) + '</span>' +
            comparePriceHTML +
          '</p>' +
          '<div class="panel__stock">' +
            '<span class="panel__stock-label">STOCK</span>' +
            stockIcon +
          '</div>' +
        '</div>' +

        optionsHTML +

        '<div class="panel__actions">' +
          atcHTML +
          '<a href="' + _esc(url) + '" class="arcade-btn arcade-btn--secondary">VIEW ITEM &#9656;</a>' +
        '</div>' +
        disclaimerHTML +
        '<p class="panel__atc-feedback" aria-live="polite"></p>' +
        (desc ? '<div class="panel__desc">' + _esc(desc) + '</div>' : '')
      );
    }

    function wireGallery(container) {
      var mainEl  = container.querySelector('.panel__gallery-main');
      var imgEl   = container.querySelector('.panel__gallery-img');
      var thumbs  = container.querySelectorAll('.panel__thumb');
      var prevBtn = container.querySelector('.panel__gallery-prev');
      var nextBtn = container.querySelector('.panel__gallery-next');

      if (!mainEl || !imgEl) return;

      var images;
      try {
        images = JSON.parse(mainEl.dataset.galleryImages || '[]');
      } catch (e) {
        images = [];
      }

      if (!images.length) return;

      var total = images.length;
      var idx   = 0;

      function goTo(i) {
        idx = (i + total) % total;
        imgEl.innerHTML = '<img src="' + images[idx] + '" alt="" loading="lazy">';
        thumbs.forEach(function (b, ti) {
          b.classList.toggle('is-active', ti === idx);
        });
      }

      thumbs.forEach(function (btn, i) {
        btn.addEventListener('click', function () { goTo(i); });
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(idx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(idx + 1); });
    }

    function wireVariants(container) {
      var selects = container.querySelectorAll('.panel__option-select');
      if (!selects.length) return;

      var atcBtn  = container.querySelector('.panel__atc-btn');
      var priceEl = container.querySelector('.panel__current-price');
      var stockEl = container.querySelector('.panel__stock');

      var variants = [];
      try {
        variants = JSON.parse((atcBtn ? atcBtn.dataset.variants : '') || '[]');
      } catch (e) {}
      if (!variants.length) return;

      /* Check if this product is tagged PreOrder */
      var cardTags = activeCard ? (activeCard.dataset.tags || '').split(',') : [];
      var cardIsPreOrder = cardTags.indexOf('PreOrder') >= 0;

      function getSelectedVariant() {
        var selectedOptions = Array.from(selects).map(function (s) { return s.value; });
        return variants.filter(function (v) {
          return selectedOptions.every(function (val, i) {
            return v['option' + (i + 1)] === val;
          });
        })[0];
      }

      function updateForVariant(variant) {
        if (!variant) return;
        var isPreOrderBtn = atcBtn && atcBtn.dataset.preorder === 'true';
        var addLabel = isPreOrderBtn ? 'PRE-ORDER NOW' : 'ADD TO CART';
        if (atcBtn && !atcBtn.href) {
          atcBtn.dataset.variant = variant.id;
          atcBtn.disabled = !variant.available && !isPreOrderBtn;
          if (variant.available || isPreOrderBtn) {
            atcBtn.removeAttribute('aria-disabled');
            atcBtn.textContent = addLabel;
          } else {
            atcBtn.setAttribute('aria-disabled', 'true');
            atcBtn.textContent = 'SOLD OUT';
          }
        }
        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price);
        }
        /* Update compare price */
        var comparePriceEl = container.querySelector('.panel__compare-price');
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (!comparePriceEl) {
            comparePriceEl = document.createElement('span');
            comparePriceEl.className = 'panel__compare-price';
            priceEl.parentNode.appendChild(comparePriceEl);
          }
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else if (comparePriceEl) {
          comparePriceEl.hidden = true;
        }
        if (stockEl) {
          var icon;
          if (cardIsPreOrder) {
            icon = '<span class="panel__stock-label">STOCK</span><svg class="stock-icon stock-icon--preorder" width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="8" cy="8" r="6.5"/><path d="M8 4.5V8l2.5 1.5"/></svg>';
          } else if (variant.available) {
            icon = '<span class="panel__stock-label">STOCK</span><svg class="stock-icon stock-icon--instock" width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="12" height="12" rx="2"/><path d="M5 8l2 2 4-4"/></svg>';
          } else {
            icon = '<span class="panel__stock-label">STOCK</span><svg class="stock-icon stock-icon--oos" width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="12" height="12" rx="2"/><path d="M5.5 5.5l5 5M10.5 5.5l-5 5"/></svg>';
          }
          stockEl.innerHTML = icon;
        }
      }

      selects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          updateForVariant(getSelectedVariant());
        });
      });
    }

    /* Add to cart */
    function wireATC(container) {
      var atcBtn   = container.querySelector('.panel__atc-btn');
      var feedback = container.querySelector('.panel__atc-feedback');
      if (!atcBtn || atcBtn.href) return;

      var addLabel = atcBtn.dataset.preorder === 'true' ? 'PRE-ORDER NOW' : 'ADD TO CART';

      atcBtn.addEventListener('click', function () {
        var variantId = atcBtn.dataset.variant;
        if (!variantId || !window.nonnomCartAPI) return;

        atcBtn.disabled = true;
        atcBtn.textContent = 'ADDING…';
        if (feedback) feedback.textContent = '';

        window.nonnomCartAPI.add(variantId, 1).then(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = addLabel;
          if (feedback) {
            feedback.textContent = 'ADDED TO CART!';
            setTimeout(function () { if (feedback) feedback.textContent = ''; }, 2500);
          }
          window.nonnomCartAPI.openDrawer();
        }).catch(function (err) {
          atcBtn.disabled = false;
          atcBtn.textContent = addLabel;
          if (feedback) feedback.textContent = (err && err.message) || 'ERROR — TRY AGAIN';
        });
      });
    }

    function flashCard(card) {
      card.classList.remove('is-flashing');
      void card.offsetWidth;
      card.classList.add('is-flashing');
      setTimeout(function () { card.classList.remove('is-flashing'); }, 400);
    }

    function selectCard(card) {
      cards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
    }

    /* Panel open/close */
    function openPanel(card, skipFocus) {
      flashCard(card);
      selectCard(card);

      if (panelOpen && activeCard !== card) {
        panelContent.style.opacity = '0';
        setTimeout(function () {
          panelContent.innerHTML = buildHTML(card);
          wireGallery(panelContent);
          wireVariants(panelContent);
          wireATC(panelContent);
          panel.scrollTop = 0;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              panelContent.style.opacity = '1';
            });
          });
        }, 200);
      } else if (!panelOpen) {
        panelContent.innerHTML = buildHTML(card);
        wireGallery(panelContent);
        wireVariants(panelContent);
        wireATC(panelContent);
        view.classList.add('is-split');
        panel.removeAttribute('aria-hidden');
        panelOpen = true;
        if (panelClose && !skipFocus) setTimeout(function () { panelClose.focus(); }, 50);
      }

      activeCard = card;
    }

    function closePanel() {
      view.classList.remove('is-split');
      panel.setAttribute('aria-hidden', 'true');
      panelOpen  = false;
      activeCard = null;
      cards.forEach(function (c) { c.classList.remove('is-selected'); });
      setTimeout(function () { panelContent.innerHTML = ''; }, 400);
    }

    function openModal(card) {
      flashCard(card);
      modalContent.innerHTML = buildHTML(card);
      wireGallery(modalContent);
      wireVariants(modalContent);
      wireATC(modalContent);
      modal.removeAttribute('aria-hidden');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (modalClose) setTimeout(function () { modalClose.focus(); }, 50);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { modalContent.innerHTML = ''; }, 400);
    }

    var tagPriority = ['NewArrivals', 'PreOrder'];

    function getTagOrder(card) {
      var tags = (card.dataset.tags || '').split(',');
      /* PreOrder first */
      if (tags.indexOf('PreOrder') >= 0) return 0;
      /* NewArrivals second */
      if (tags.indexOf('NewArrivals') >= 0) return 1;
      /* On Sale third (compare_at_price based) */
      if (card.dataset.onSale === 'true') return 2;
      /* Everything else */
      return 3;
    }

        /* Priority sorting */
    function sortByPriority() {
      var grid = document.getElementById('catalogue-grid');
      if (!grid) return;
      var sorted = Array.from(cards).sort(function (a, b) {
        return getTagOrder(a) - getTagOrder(b);
      });
      sorted.forEach(function (card) { grid.appendChild(card); });
    }

        /* Filtering */
    function setFilter(filter, tagFilter) {
      if (panelOpen) closePanel();

      filterBtns.forEach(function (btn) {
        var active = btn.dataset.filter === filter;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
      });

      var visible = 0;

      if (filter === 'on-sale' || tagFilter === 'Sale') {
        cards.forEach(function (card) {
          var match = card.dataset.onSale === 'true';
          card.classList.toggle('is-hidden', !match);
          if (match) visible++;
        });
      } else if (tagFilter) {
        cards.forEach(function (card) {
          var tags = (card.dataset.tags || '').split(',');
          var match = tags.indexOf(tagFilter) >= 0;
          card.classList.toggle('is-hidden', !match);
          if (match) visible++;
        });
      } else {
        /* Collection-based filtering */
        cards.forEach(function (card) {
          var collections = (card.dataset.collection || '').trim().split(/\s+/);
          var match = collections.indexOf(filter) !== -1;
          card.classList.toggle('is-hidden', !match);
          if (match) visible++;
        });sortByPriority();
      }

      if (emptyState) emptyState.hidden = visible > 0;
    }

    cards.forEach(function (card) {
      card.setAttribute('tabindex', '0');

      function activateCard(e) {
        e.preventDefault();
        if (e.target.closest('.arcade-btn')) return;
        isMobile() ? openModal(card) : openPanel(card);
      }

      card.addEventListener('click', activateCard, sig);
      card.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        activateCard(e);
      }, sig);var preloaded = false;
      function preloadImages() {
        if (preloaded) return;
        preloaded = true;
        var images = getImages(card);
        images.forEach(function (src) {
          var img = new Image();
          img.src = src;
        });
      }
      card.addEventListener('mouseenter', preloadImages, sig);
      card.addEventListener('touchstart', preloadImages, { passive: true });
    });

    if (panelClose) panelClose.addEventListener('click', closePanel, sig);
    if (modalClose) modalClose.addEventListener('click', closeModal, sig);

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setFilter(btn.dataset.filter, btn.dataset.tag || null);
      }, sig);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (modal && modal.classList.contains('is-open')) closeModal();
      else if (panelOpen) closePanel();
    }, sig);

    window.matchMedia('(max-width: 767px)').addEventListener('change', function (e) {
      if (e.matches && panelOpen) closePanel();
    }, sig);

    /* URL filter params */
    var urlParams = new URLSearchParams(window.location.search);
    var urlFilter = urlParams.get('filter');
    var initFilter, initTag;

    if (urlFilter) {var matchBtn = Array.from(filterBtns).filter(function (btn) {
        return btn.dataset.filter === urlFilter;
      })[0];

      if (matchBtn) {
        initFilter = matchBtn.dataset.filter;
        initTag = matchBtn.dataset.tag || null;
      } else {
        /* Ignore unrecognized filter values */
        initFilter = filterBtns[0] ? filterBtns[0].dataset.filter : 'all';
        initTag = null;
      }
    } else {
      var firstBtn = filterBtns[0];
      initFilter = firstBtn ? firstBtn.dataset.filter : 'all';
      initTag = firstBtn ? (firstBtn.dataset.tag || null) : null;
    }

    sortByPriority();
    setFilter(initFilter, initTag);(function () {
      var params     = new URLSearchParams(window.location.search);
      var openHandle = params.get('open');
      if (!openHandle || !/^[a-z0-9\-]+$/.test(openHandle)) return;

      history.replaceState(null, '', window.location.pathname);

      var targetCard = null;
      cards.forEach(function (card) {
        if (card.dataset.handle === openHandle) targetCard = card;
      });
      if (!targetCard) return;

      setTimeout(function () {
        targetCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () {
          isMobile() ? openModal(targetCard) : openPanel(targetCard, true);
        }, 300);
      }, 100);
    })();
  }

  window.initCatalogue = init;
  init();

})();
